import { FC, useContext, useState } from "react";
import NotificationDispatch, {
  showErrorNotification,
  showSuccessNotification,
} from "../../../context/notificationContext";
import { useI18n } from "../../../hooks/useTranslations";
import { useDefaultTasksApi } from "../../../http/defaultTasks/api";
import { UpsertDefaultTask } from "../../../http/defaultTasks/types";
import SvgAdd from "../../icons/Add";
import Button from "../../ui/Button";
import ModalDialog from "../../ui/ModalDialog";
import DefaultTaskForm, { DefaultTaskFormBody } from "./DefaultTaskForm";

const CreateDefaultTaskButton: FC = () => {
  const i18n = useI18n();
  const [show, setShow] = useState(false);
  const dispatch = useContext(NotificationDispatch);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const defaultTasksApi = useDefaultTasksApi();

  const onSubmit = async (formData: DefaultTaskFormBody) => {
    const body: UpsertDefaultTask = {
      name: formData.name,
      categories: formData.categories,
      defaultDueDateTypeId: formData.defaultDueDateType?.id,
    };

    setIsSubmitting(true);
    try {
      await defaultTasksApi.insertAdminDefaultTask(body);
      dispatch(showSuccessNotification(i18n.t));
      setShow(false);
    } catch (error) {
      dispatch(showErrorNotification(i18n, error));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Button buttonProps={{ onClick: () => setShow(true) }} glyph={SvgAdd} />
      {!!show && (
        <ModalDialog onClose={() => setShow(false)} title={i18n.t.defaultTasks.new}>
          <DefaultTaskForm onSubmit={onSubmit} isDisabled={isSubmitting} />
        </ModalDialog>
      )}
    </>
  );
};

export default CreateDefaultTaskButton;
